import { ColumnsType } from 'antd/lib/table';
import { THistoryData } from 'api/history';

import { TFunctionCustom } from 'hooks';

const columns = (t: TFunctionCustom, precisionsConfigs: any): ColumnsType<THistoryData> => [
  {
    title: t('historypage.columns.coin'),
    key: 'coin',
    dataIndex: 'coin',
    sorter: true,
    showSorterTooltip: false,
    render(value: any) {
      return <span>{value}</span>;
    },
  },
  {
    title: t('exchange.columns.total_balance'),
    key: 'total_balance',
    dataIndex: 'total_balance',
    sorter: true,
    showSorterTooltip: false,
    render(value: any) {
      return <span>{value}</span>;
    },
  },
  {
    title: t('exchange.columns.in_order'),
    key: 'in_order',
    dataIndex: 'in_order',
    render(value: any) {
      return <span>{value}</span>;
    },
  },
  {
    title: t('exchange.columns.debt'),
    key: 'debt',
    dataIndex: 'debt',
    render(value: any) {
      return <span>{value}</span>;
    },
  },
];

export default columns;
